import { faUsersMedical } from "@fortawesome/pro-duotone-svg-icons";
import ColorChangingIcon from "../Common/UI/ColorChangingIcon";

function EditPermissionsButton({ onClick, hidden }) {
  return (
    <ColorChangingIcon
      title="Edit Dataset Permissions"
      icon={faUsersMedical}
      initialPrimaryColor="#66682C"
      initialSecondaryColor="#0078D4"
      margin="20px 0 0 0"
      primaryOpacity={1}
      secondaryOpacity={1}
      onClick={onClick}
      hidden={hidden}
    />
  );
}

export default EditPermissionsButton;
